'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    border-radius: ', ';\n'], ['\n    ', '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    border-radius: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    border-bottom: none;\n    border: ', '\n    border-radius: ', ';\n    padding: .25rem 1rem;\n    margin-bottom: 2px;\n'], ['\n    border-bottom: none;\n    border: ', '\n    border-radius: ', ';\n    padding: .25rem 1rem;\n    margin-bottom: 2px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  border-radius: 4px;\n  object-fit: cover;\n'], ['\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  border-radius: 4px;\n  object-fit: cover;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  font-family: \'Poppins\', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  color: white;\n  margin-right: 10px;\n  border-radius: 4px;\n  background-color: ', ';\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  font-family: \'Poppins\', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  color: white;\n  margin-right: 10px;\n  border-radius: 4px;\n  background-color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _alignments = require('../../../constants/alignments');

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _getTooltip = require('../../../helpers/getTooltip');

var _getTooltip2 = _interopRequireDefault(_getTooltip);

var _getFieldValidationInfo = require('../../../helpers/getFieldValidationInfo');

var _getFieldValidationInfo2 = _interopRequireDefault(_getFieldValidationInfo);

var _separator = require('../../../atoms/separator');

var _separator2 = _interopRequireDefault(_separator);

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _grid = require('../../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _error = require('../../../atoms/icons/error');

var _error2 = _interopRequireDefault(_error);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _tooltip = require('../../../molecules/tooltip2');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _fileUploader = require('../../fileUploader');

var _fileUploader2 = _interopRequireDefault(_fileUploader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ValidationBanner = _styledComponents2.default.div(_templateObject, function (_ref) {
    var type = _ref.type;
    return type === 'error' ? 'background: rgba(255, 0, 78, .15);' : type === 'warning' ? 'background: rgba(255, 129, 0, .15);' : null;
}, function (_ref2) {
    var index = _ref2.index;
    return index === 0 ? '0 0 4px 4px' : '4px';
});

var ValueContainer = _styledComponents2.default.div(_templateObject2, function (_ref3) {
    var errors = _ref3.errors,
        warnings = _ref3.warnings;
    return errors ? '1px solid rgba(255, 0, 78, 1);' : warnings ? '1px solid rgba(255, 129, 0, 1);' : 'none';
}, function (_ref4) {
    var errors = _ref4.errors,
        warnings = _ref4.warnings;
    return errors || warnings ? '4px 4px 0 0' : 'none';
});

var ImageThumbnail = _styledComponents2.default.img(_templateObject3);

var FileThumbnail = _styledComponents2.default.div(_templateObject4, _colors.Colors.StrokeMedium);

var PictureIcon = function PictureIcon() {
    return _react2.default.createElement(
        'svg',
        { width: '50', height: '40', viewBox: '0 0 50 40', fill: _colors.Colors.StrokeMedium, xmlns: 'http://www.w3.org/2000/svg' },
        _react2.default.createElement(
            'g',
            { transform: 'translate(1,2)' },
            _react2.default.createElement('path', { d: 'M8.68642 5.57368L10.0386 2.42943C10.6739 0.952091 12.0915 0 13.6557 0H24.3443C25.9085 0 27.3261 0.952091 27.9614 2.42943L29.3136 5.57368C29.5677 6.16462 30.1347 6.54545 30.7604 6.54545H34.0417C36.2278 6.54545 38 8.37702 38 10.6364V31.9091C38 34.1684 36.2278 36 34.0417 36H3.95833C1.77221 36 0 34.1684 0 31.9091V10.6364C0 8.37702 1.77221 6.54545 3.95833 6.54545H7.23955C7.86527 6.54545 8.43229 6.16462 8.68642 5.57368ZM19 29.8636C24.0281 29.8636 28.1042 25.651 28.1042 20.4545C28.1042 15.258 24.0281 11.0455 19 11.0455C13.9719 11.0455 9.89583 15.258 9.89583 20.4545C9.89583 25.651 13.9719 29.8636 19 29.8636ZM19 25.7727C16.158 25.7727 13.8542 23.3917 13.8542 20.4545C13.8542 17.5174 16.158 15.1364 19 15.1364C21.842 15.1364 24.1458 17.5174 24.1458 20.4545C24.1458 23.3917 21.842 25.7727 19 25.7727Z' })
        )
    );
};

var FormFileUploader = function (_React$Component) {
    _inherits(FormFileUploader, _React$Component);

    function FormFileUploader() {
        _classCallCheck(this, FormFileUploader);

        return _possibleConstructorReturn(this, (FormFileUploader.__proto__ || Object.getPrototypeOf(FormFileUploader)).apply(this, arguments));
    }

    _createClass(FormFileUploader, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var editMode = this.props.editing && this.props.allowEdit;

            var _getFieldValidationIn = (0, _getFieldValidationInfo2.default)(this.props.validationInfo, this.props.pageCode, this.props.sectionCode, this.props.fieldCode, this.props.rowId),
                errors = _getFieldValidationIn.errors,
                warnings = _getFieldValidationIn.warnings;

            var getFileExtension = function getFileExtension(fileName) {
                return fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2).toUpperCase();
            };

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_separator2.default, { bottom: _sizes.Sizes.sm, orientation: 'horizontal', solid: true }),
                _react2.default.createElement(
                    _grid2.default,
                    null,
                    _react2.default.createElement(
                        _row2.default,
                        null,
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 12, md: 5, nogutter: true },
                            _react2.default.createElement(
                                _container2.default,
                                { inline: true, verticalAlignment: _alignments.Alignments.center },
                                _react2.default.createElement(_label2.default, { bold: true, textAlign: _alignments.Alignments.left, text: this.props.label }),
                                this.props.pageCode && this.props.sectionCode && this.props.fieldCode && _react2.default.createElement(_tooltip2.default, {
                                    header: this.props.label,
                                    text: (0, _getTooltip2.default)(this.props.tooltipInfo, this.props.pageCode, this.props.sectionCode, this.props.fieldCode),
                                    saveHandler: this.props.saveTooltipInfo,
                                    reduceHandler: function reduceHandler() {
                                        return function (value) {
                                            _this2.props.reduceTooltipInfoElement({
                                                newTooltip: value,
                                                pageCode: _this2.props.pageCode,
                                                sectionCode: _this2.props.sectionCode,
                                                fieldCode: _this2.props.fieldCode
                                            });
                                        };
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(_column2.default, { xs: 0, md: 1 }),
                        editMode && _react2.default.createElement(
                            _column2.default,
                            { xs: 12, md: 6, nogutter: true },
                            _react2.default.createElement(_fileUploader2.default, {
                                config: this.props.config,
                                initialFiles: this.props.initialFiles,
                                onUploadStart: this.props.onUploadStart,
                                onUploadProgress: this.props.onUploadProgress,
                                onUploadComplete: this.props.onUploadComplete,
                                onUploadError: this.props.onUploadError,
                                onUploadCancel: this.props.onUploadCancel,
                                onFileDelete: this.props.onFileDelete,
                                onFilesChange: this.props.onFilesChange
                            })
                        ),
                        !editMode && _react2.default.createElement(
                            _column2.default,
                            { xs: 12, md: 6, nogutter: true },
                            _react2.default.createElement(
                                ValueContainer,
                                { errors: errors.length > 0, warnings: warnings.length > 0 },
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    this.props.initialFiles.map(function (file, index) {
                                        var isImage = file.contentType.startsWith('image/');
                                        var thumbnailUrl = file.thumbnailUrl;
                                        var fileExtension = getFileExtension(file.fileName);

                                        return _react2.default.createElement(
                                            'li',
                                            { key: index, style: { listStyleType: 'none' } },
                                            _react2.default.createElement(
                                                _container2.default,
                                                { inline: true, verticalAlignment: _alignments.Alignments.center, bottom: _sizes.Sizes.xs },
                                                !isImage ? _react2.default.createElement(
                                                    FileThumbnail,
                                                    null,
                                                    '.' + fileExtension
                                                ) : thumbnailUrl ? _react2.default.createElement(ImageThumbnail, { src: thumbnailUrl, alt: file.fileName }) : _react2.default.createElement(PictureIcon, null),
                                                _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left, text: file.fileName })
                                            )
                                        );
                                    })
                                )
                            ),
                            errors.length > 0 && errors.map(function (error, index) {
                                return _react2.default.createElement(
                                    ValidationBanner,
                                    { key: index, type: 'error', index: index },
                                    _react2.default.createElement(_error2.default, { mode: 'error', size: 24 }),
                                    _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left, text: error.message, color: _colors.Colors.Error })
                                );
                            }),
                            warnings.length > 0 && warnings.map(function (warning, index) {
                                return _react2.default.createElement(
                                    ValidationBanner,
                                    { key: index, type: 'warning', index: index },
                                    _react2.default.createElement(_error2.default, { mode: 'warning', size: 24 }),
                                    _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left, text: warning.message, color: _colors.Colors.Warning })
                                );
                            })
                        )
                    )
                )
            );
        }
    }]);

    return FormFileUploader;
}(_react2.default.Component);

exports.default = FormFileUploader;